<p-card>

    <form [formGroup]="customerForm">
        <div class="formgrid grid">
            <div class="field col-12 flex justify-content-between align-items-center">

                <div class="flex align-items-start" style="margin-bottom: 15px;">
                    <div>
                        <p-button label="Save" class="p-button-outlined ml-2" icon=" pi pi-save" size="small"
                            (click)="createCustomer(customerForm.value)"></p-button>
                    </div>
                </div>
                <div>
                    <label class="block label-required" style="font-weight: bold;">Required Field</label>
                </div>
            </div>

            &nbsp;

            <div class="field col-12 flex">
                <div class="flex align-items-center">
                    <p-radioButton value="individual" inputId="customertype_ii" formControlName="type"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.type.errors }"></p-radioButton>
                    <label for="customertype_ii" class="ml-2">Individual</label>
                </div>
                <div class="flex align-items-center ml-5">
                    <p-radioButton value="company" inputId="customertype_cc" formControlName="type"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.type.errors }"></p-radioButton>
                    <label for="customertype_cc" class="ml-2">Company</label>
                </div>
                <div class="flex align-items-center ml-5">
                    <p-checkbox label="Active" formControlName="isActive" [binary]="true"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.isActive.errors?.['requiredTrue'] }"></p-checkbox>
                    <small *ngIf="submitted && formControls.isActive.errors?.['requiredTrue']"
                        class="text-red-500">Required field.</small>
                </div>
                <div class="flex align-items-center ml-5">
                    <p-checkbox label="Ship To Customer" formControlName="IsShipToCustomer" [binary]="true"
                        value="true"></p-checkbox>
                </div>
            </div>
        </div>


        <div class="grid">

            <div class="col">

                <div class="field text-left" style="display: flex; flex-direction: column; align-items: flex-start;">
                    <label for="website" class="label-required display">Customer Code</label>
                    <div style="display: flex; align-items: center;">
                        <input pInputText placeholder="e.g P307" type="text" (blur)="checkCustomerCode()"
                            class="w-full p-inputtext-sm" formControlName="customerCode"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.customerCode.errors}" />
                        <div style="margin-left: 10px;">
                            <p-checkbox formControlName="manualEntry" (onChange)="manualEntry()" [binary]="true"
                                label="Manual Entry" value="true"></p-checkbox>
                        </div>

                    </div>
                    <small *ngIf="submitted && formControls.customerCode.errors" id="name-error"
                        class="text-red-500">Required field.</small>
                </div>

                <div class="field">
                    <label for="website" class="label-required display">Customer Name</label>
                    <input pInputText placeholder="e.g Xyz" formControlName="customerName" class="w-full p-inputtext-sm"
                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.customerName.errors }" />
                    <small *ngIf="submitted && formControls.customerName.errors" id="name-error"
                        class="text-red-500">Required field.</small>
                </div>


            </div>


            <div class="col">

                <div class="field w-full form-field">
                    <label class="label-required">GST Treatment</label>
                    <div>
                        <p-dropdown formControlName="gstTreatment" [options]="gstTreatmentList" optionLabel="name"
                            placeholder="Select GST Treatment" class="w-full"
                            [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.gstTreatment.errors }">

                            <ng-template let-item pTemplate="item">
                                {{item.code}} - {{item.name}}
                            </ng-template>

                            <ng-template let-item pTemplate="selectedItem">
                                {{item?.code}} - {{item?.name}}
                            </ng-template>

                        </p-dropdown>
                    </div>
                    <small *ngIf="submitted && formControls.gstTreatment.errors" id="name-error"
                        class="text-red-500">Required field.</small>
                </div>
                <div class="field" style="margin-top: 20px;">
                    <label for="website">Customer Description</label>
                    <input pInputText placeholder="e.g Abc" class="w-full p-inputtext-sm"
                        formControlName="customerDescription" />
                </div>

            </div>



        </div>

        <p-tabView>
            <p-tabPanel header="General Information">

                <div class="grid ">
                    <div class="col">
                        <div class="field text-left" formGroupName="address">
                            <label for="address" class="label-required display">Address</label>
                            <input pInputText placeholder="Street Address" class="w-full p-inputtext-sm"
                                formControlName="addressLine1"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.addressLine1.errors}" />
                            <small *ngIf="submitted && formControls.address.controls.addressLine1.errors"
                                id="name-error" class="text-red-500">Required field.</small>
                            <input pInputText placeholder="Street Address 2" class="w-full p-inputtext-sm mt-1"
                                formControlName="addressLine2" />

                            <div class="flex mt-1">
                                <div>
                                    <input pInputText placeholder="City" class="w-full" formControlName="city"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.city.errors }" />
                                    <small *ngIf="submitted && formControls.address.controls.city.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>

                                <!--div class=" ml-1">
                                    <p-autoComplete [dropdown]="true" placeholder="State" (onBlur)="checkState()"
                                        [forceSelection]="true" [readonly]="true" (onSelect)="setState($event)"
                                        formControlName="state" [suggestions]="filterStates"
                                        (completeMethod)="filterState($event)" field="stateName"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }"></p-autoComplete>
                                    <small *ngIf="submitted && formControls.address.controls.state.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div-->

<div class=" ml-1">
                                    <p-autoComplete [dropdown]="true" placeholder="State" (onBlur)="checkState()"
                                        [forceSelection]="true" [readonly]="true" (onSelect)="setState($event)"
                                        formControlName="state" [suggestions]="filterStates"
                                        (completeMethod)="filterState($event)" field="stateName"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.state.errors }">
                                        <ng-template let-state pTemplate="item">
                                            {{ state.stateCode  }} - {{ state.stateName }}
                                        </ng-template>
                                    </p-autoComplete>
                                    <small *ngIf="submitted && formControls.address.controls.state.errors"
                                        id="name-error" class="text-red-500">Required field.</small>
                                </div>
                                
                                <div class=" ml-1">
                                    <input pInputText placeholder="Zip" class="w-full" formControlName="zip"
                                        [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.zip.errors }" />
                                    <small *ngIf="submitted && formControls.address.controls.zip.errors" id="name-error"
                                        class="text-red-500">Required field.</small>
                                    <small
                                        *ngIf="formControls.address.controls.zip.value && formControls.address.controls.zip.value.length !== 6"
                                        id="zip-invalid-error" class="text-red-500">Zip code must be exactly 6
                                        digits.</small>
                                </div>

                            </div>

                            <input pInputText placeholder="Country" class="w-full p-inputtext-sm mt-1"
                                formControlName="country"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.address.controls.country.errors}" />
                            <small *ngIf="submitted && formControls.address.controls.country.errors" id="name-error"
                                class="text-red-500">Required field.</small>
                        </div>

                        <div class="field text-left">
                            <label for="tags">GSTIN
                                <span class="text-red-500" *ngIf="customerForm.get('gstTreatment')?.value?.allowsGSTIN">
                                    *
                                </span>
                            </label>
                            <input pInputText placeholder="GSTIN" class="w-full p-inputtext-sm"
                                formControlName="GSTIN" />
                            <small class="p-error" *ngIf="submitted && formControls.GSTIN?.errors?.['required']">
                                GSTIN is required.
                            </small>

                            <small class="p-error" *ngIf="submitted && formControls.GSTIN?.errors?.['pattern']">
                                Please enter a valid GSTIN.
                            </small>
                        </div>

                    </div>
                    <div class="col ">
                        <div class="field text-left ">
                            <label for="phone">Phone</label>
                            <input min="0" pInputText placeholder="phone" class="w-full p-inputtext-sm"
                                formControlName="phone" (input)="validater()" style="height: 40px;"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.phone.errors }" />
                            <small *ngIf="submitted && formControls.phone.errors" id="name-error"
                                class="text-red-500">Invalid phone number </small>
                            <small *ngIf="submitted && formControls.phone.hasError('pattern')" id="name-error"
                                class="text-red-500"> Please enter a 10-digit phone number </small>
                            <small *ngIf="submitted && formControls.phone.hasError('maxlength')" id="name-error"
                                class="text-red-500">phone number should not exceed more than 10 </small>
                        </div>
                        <div class="field text-left">
                            <label for="mobile">Mobile</label>
                            <input pInputText placeholder="mobile" class="w-full p-inputtext-sm"
                                formControlName="mobile" (input)="validater()"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.mobile.errors }"
                                style="height: 40px;" />
                            <small *ngIf="submitted && formControls.mobile.errors?.['required']" id="name-error"
                                class="text-red-500">Required field.</small>
                            <small *ngIf="submitted && formControls.mobile.errors?.['pattern']" id="name-error"
                                class="text-red-500">Invalid mobile number. Please enter 10-digit mobile number.</small>
                        </div>
                        <div class="field text-left">
                            <label for="email">Email</label>
                            <input pInputText placeholder="Email" class="w-full p-inputtext-sm" formControlName="email"
                                [ngClass]="{'ng-invalid ng-dirty': submitted && formControls.email.errors }"
                                style="height: 40px;" />
                            <small *ngIf="submitted && formControls.email.errors?.['required']" id="name-error"
                                class="text-red-500">Required field.</small>
                            <small *ngIf="submitted && formControls.email.errors?.['email']" id="name-error"
                                class="text-red-500">Invalid email address. Example: xyz&commat;gmail.com.</small>

                        </div>
                        <div>
                            <label for="termsCode"><b>Payment Terms</b></label>
                            <div class="p-inputgroup p-lookup">
                                <input pInputText class="w-full p-inputtext-sm" formControlName="termsDescription" />
                                <button type="button" pButton pRipple severity="info" icon="pi pi-search"
                                    (click)="getTermsCode()"></button>
                            </div>
                        </div>

                    </div>
                </div>

            </p-tabPanel>
        </p-tabView>


    </form>
</p-card>